import { MinTableKey } from "./table";

export const CONTEXTS = {
  WORK: "work",
  HOME: "home",
} as const;
export type Context = (typeof CONTEXTS)[keyof typeof CONTEXTS];

export type TodoData = {
  type: "todo";
  id: string;
  userId: string;
  title: string;
  notes?: string;
  context: Context;
  // A todo with children acts as a project/group; a todo with none is a
  // plain leaf. Nesting is capped at one level, enforced client-side only
  // (a todo that already has children can't itself be given a parentId,
  // and the parent-picker only offers todos with none) — the server just
  // rejects the trivial self-reference case.
  parentId?: string;
  priority?: number;
  complexity?: number;
  done: boolean;
  doneAt?: string;
  scheduledDate?: string; // YYYY-MM-DD, always client-local — never computed server-side
  order: number;
  timesScheduled: number;
  createdAt: string; // ISO, server-set
  updatedAt: string; // ISO, server-set
};

export type TodoDBData = MinTableKey & TodoData;
